import type { IconNode } from '../types';

/**
 * @name watch-square-alarm
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTUuOCA2LS41LTIuNGMtLjItMS0xLTEuNi0yLTEuNmgtMi43YTIgMiAwIDAgMC0yIDEuNkw4LjIgNiIgLz4KICA8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHg9IjYiIHk9IjYiIHJ4PSIyIiAvPgogIDxwYXRoIGQ9Im04LjIgMTggLjUgMi40Yy4yIDEgMSAxLjYgMiAxLjZoMi43YTIgMiAwIDAgMCAyLTEuNmwuNS0yLjQiIC8+CiAgPHBhdGggZD0iTTEyIDEwdjJsMSAxIiAvPgogIDxwYXRoIGQ9Ik0yIDE2YzAgMi4xIDEuMSA0IDIuNyA1IiAvPgogIDxwYXRoIGQ9Ik0yMiA4YzAtMi4xLTEuMS00LTIuNy01IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/watch-square-alarm
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const watchSquareAlarm: IconNode = [
  ['path', { d: 'm15.8 6-.5-2.4c-.2-1-1-1.6-2-1.6h-2.7a2 2 0 0 0-2 1.6L8.2 6', key: '1qkycp' }],
  ['rect', { width: '12', height: '12', x: '6', y: '6', rx: '2', key: '12p1cq' }],
  ['path', { d: 'm8.2 18 .5 2.4c.2 1 1 1.6 2 1.6h2.7a2 2 0 0 0 2-1.6l.5-2.4', key: 'e2n0tu' }],
  ['path', { d: 'M12 10v2l1 1', key: 'qdur31' }],
  ['path', { d: 'M2 16c0 2.1 1.1 4 2.7 5', key: '1r5jxm' }],
  ['path', { d: 'M22 8c0-2.1-1.1-4-2.7-5', key: '1qoma0' }],
];

export default watchSquareAlarm;
